// components
import Tag from '../../../tag/tag'

type ClaimAssistPredictionsTagProps = {
	readonly title?: string
	readonly tagLabel?: string
}

const ClaimAssistPredictionsTag = ({
	title,
	tagLabel,
}: ClaimAssistPredictionsTagProps): JSX.Element => {
	return (
		<>
			{title && tagLabel && (
				<div>
					<h3>{title}</h3>
					<p>
						<Tag
							theme={tagLabel.toLocaleLowerCase()}
							label={tagLabel}
						/>
					</p>
				</div>
			)}
		</>
	)
}
export default ClaimAssistPredictionsTag
